import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../core/animations';
import { Cliente } from '../../../../core/modelos/cliente';
import { ClientesService } from '../clientes.service';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';

@Component({
    selector: 'fuse-clientes-detalle',
    templateUrl: './clientes-detalle.component.html',
    styleUrls: ['./clientes-detalle.component.scss'],
    animations: fuseAnimations
})
export class ClientesDetalleComponent implements OnInit {

    cliente: Cliente;
    idCliente: number;

    formulario: FormGroup;

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private clientesService: ClientesService,
        private notificaciones: NotificacionesService,
        private router: Router
    ) {
        // Traigo el cliente por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idCliente = params['idCliente'];
        });
    }

    ngOnInit() {
        this.clientesService.getCliente(this.idCliente).subscribe(
            data => {
                if (data.success) {
                    this.cliente = data.items;
                    this.cliente.logo = this.cliente.logo ? 'data:image/jpeg;base64,' + this.cliente.logo : null;
                    this.crearFormulario();
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteNOObtenido);
                    this.router.navigate(['clientes']);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {
        this.formulario = this.fb.group({
            'nombre': new FormControl({ value: this.cliente.nombre, disabled: true }),
            'email': new FormControl({ value: this.cliente.email, disabled: true }),
            'codigo': new FormControl({ value: this.cliente.codigo, disabled: true }),
            'usuarios_utilizados': new FormControl({ value: this.cliente.usuarios_utilizados, disabled: true }),
            'usuarios_totales': new FormControl({ value: this.cliente.usuarios_totales, disabled: true }),
            'proyectos_creados': new FormControl({ value: this.cliente.proyectos_creados, disabled: true }),
            'max_proyectos': new FormControl({ value: this.cliente.max_proyectos, disabled: true }),
            'logo': new FormControl({ value: this.cliente.logo, disabled: true }),
            'usuarioAWS': new FormControl({ value: this.cliente.userAWS, disabled: true }),
            'passwordAWS': new FormControl({ value: this.cliente.passwordAWS, disabled: true }),
            'bucketAWS': new FormControl({ value: this.cliente.bucketAWS, disabled: true }),
            'powerBI': new FormControl({ value: this.cliente.general_powerbi, disabled: true }),
            'hide_filters': new FormControl({ value: this.cliente.hide_filters, disabled: true }),
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/clientes/detalle/clientes-detalle.component.ts